(function(){
    angular
        .module('app')
        .directive('ngCkeditoralt', ckeditoralt);

        ckeditoralt.$inject = ['$timeout'];
        function ckeditoralt($timeout){
            return {
            restrict:'A',
            replace: true,
            transclude: true,
            scope: { control : "=" },
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                    //console.log(scope);
                    scope.parentScope =  scope.control;
                    
                    var name = $element.attr("id");
                    CKEDITOR.replace(name,{
                        enterMode : CKEDITOR.ENTER_P
                    })
                    //console.log("TEST CKEDIT");

                    CKEDITOR.instances[name].on('change', function() {
                        //console.log("E");
                        scope.$apply(function(){
                            //console.log(scope.$parent);
                                ngModel.$setViewValue(CKEDITOR.instances[name].getData());
                        })
                    });
                    CKEDITOR.instances[name].on( 'mode', function() {
                        // Debugger.log('ckeditor mode change: '+ this.mode);
                        if ( this.mode == 'source' ) {
                            var editable = CKEDITOR.instances[name].editable();
                            editable.attachListener( editable, 'input', function() {
                                // Debugger.log('ckeditor source input change');
                                 CKEDITOR.instances[name].fire('change');
                            } );
                        }
                    } );
                });
            }
          }
      }
})();